export default __webpack_public_path__ + "static/media/food.ce817819.svg";